export default __webpack_public_path__ + "static/media/cube-images.81e87a04.png";